/** Гарантирует непустой recommendation_algorithm_id в sogu-событиях, если API вернул пустое значение. */
export const LISTING_RECOMMENDATIONS_ALGORITHM_FALLBACK_ID = 'listing_recommendations_fallback';
